import React, { useMemo, useState } from 'react';
import CardContainer from 'components/Tvendo/Common/CardContainer';
import RegularButton from 'components/CustomButtons/Button';
import GridContainer from 'components/Grid/GridContainer';
import { DataGrid, esES } from '@material-ui/data-grid';
import Collapse from '@material-ui/core/Collapse';
import GridItem from 'components/Grid/GridItem';
import Delete from '@material-ui/icons/Delete';
import Table from 'components/Table/Table';
import { wsPost } from 'services/WService';
import { formatDate } from 'hooks/Pipe';
import TextField from '@mui/material/TextField';
import { makeStyles } from '@material-ui/core/styles';
import { InputAdornment, Tooltip } from '@material-ui/core';
import { Icon, IconButton } from '@material-ui/core';
import { HelpOutline } from '@material-ui/icons';

const columns = [
  { field: 'TaxDate', headerName: 'Fecha Depósito', width: 140, editable: true },
  { field: 'DpsBank', headerName: 'Banco', width: 160, editable: true },
  { field: 'account', headerName: 'Cuenta', width: 200, editable: true },
  { field: 'Ref2', headerName: 'Referencia (Nro Op)', width: 200, editable: true },
  { field: 'LocTotal', headerName: 'Monto', width: 150, sortable: false, editable: true },
  { field: 'U_SYP_MPPG', headerName: 'Método pago', width: 150, editable: true },
  { field: 'Memo', headerName: 'Descripción (Comentario)', width: 280, editable: true },
  //
  // { field: 'BanckAcct', headerName: 'Cta Destino', width: 140 },
  // { field: 'AllocAcct', headerName: 'Cta Origen', width: 140 },
];

function DepositGroup(props) {
  const { group, index, deleteGroup, deleteItemFromGroup, setGroups } = props;

  function updateItemField(groupId, itemId, field, newValue) {
    setGroups((prevGroups) =>
      prevGroups.map((g) =>
        g.id !== groupId
          ? g
          : {
              ...g,
              items: g.items.map((item) =>
                item.id === itemId ? { ...item, [field]: newValue } : item
              ),
            }
      )
    );
  }
  return (
    <GridItem key={group.id} xs={12} md={6}>
      <CardContainer icon={null}>
        <GridContainer>
          <GridItem xs={12}>
            <p>Grupo {index + 1}</p>
            <p>
              Cuenta destino: {group.CtaDestino} ({group.BanckAcct})
            </p>
            <p>
              Cuenta origen: {group.CtaOrigen} ({group.AllocAcct})
            </p>
            <p>Fecha de contabilización: {formatDate(group.DeposDate, 'F')}</p>
            <RegularButton
              justIcon
              round
              color="danger"
              style={{
                position: 'absolute',
                top: '10px',
                right: '10px',
              }}
              onClick={() => deleteGroup(group)}
            >
              <Delete />
            </RegularButton>
          </GridItem>
          <GridItem xs={12}>
            <div style={{ height: '400px', overflow: 'auto' }}>
              <Table
                tableHead={[
                  '#',
                  'Fecha Depósito',
                  'Banco',
                  'Cuenta',
                  'Referencia (Nro Op)',
                  'Monto',
                  'Método pago',
                  'Descripción (Comentario)',
                  'Eliminar',
                ]}
                tableData={group.items.map((item, index) => {
                  return [
                    index + 1,
                    <TextField
                      key={`TaxDate-${item.id}`}
                      variant="outlined"
                      size="small"
                      value={item.TaxDate || ''}
                      onChange={(e) =>
                        updateItemField(group.id, item.id, 'TaxDate', e.target.value)
                      }
                    />,
                    item.DpsBank,
                    item.account,
                    <TextField
                      key={`Ref2-${item.id}`}
                      variant="outlined"
                      size="small"
                      value={item.Ref2 || ''}
                      onChange={(e) =>
                        updateItemField(group.id, item.id, 'Ref2', e.target.value)
                      }
                    />,
                    item.LocTotal,
                    item.U_SYP_MPPG,
                    item.Memo,
                    <RegularButton
                      justIcon
                      round
                      color="danger"
                      disabled={group.items.length <= 1}
                      onClick={() => deleteItemFromGroup(group, item)}
                    >
                      <Delete />
                    </RegularButton>,
                  ];
                })}
              />
            </div>
          </GridItem>
        </GridContainer>
      </CardContainer>
    </GridItem>
  );
}

  // Definir los estilos
  const useStyles = makeStyles(() => ({
    rowMismatch: {
      backgroundColor: '#ffebee !important',
      color: '#b71c1c !important',
      '&:hover': {
        backgroundColor: '#ffcdd2 !important', // Color al hacer hover
      },
    },
    rowRefUsed: {
      backgroundColor: '#fff9c4 !important',
      color: '#795548 !important',
      '&:hover': {
        backgroundColor: '#fff59d !important',
      },
    },
  }));
function ImportDeposits(props) {
  const classes = useStyles();
  const { importData = [], setImportData } = props;
  const { mismatchIds = new Set() } = props;
  const { selectionModel, setSelectionModel } = props;
  const { groups, setGroups, setValidateExtracto } = props;
  const [procesing, setProcessing] = useState(false);
  const [icon, setIcon] = useState(props.icon || 'helpOutline');

  function deleteDeposit(row) {
    setImportData((importData) => {
      let newImportData = [...importData];
      let index = newImportData.findIndex((item) => item.id === row.id);
      newImportData.splice(index, 1);
      return newImportData;
    });
  }

  function deleteGroup(group) {
    if (!window.confirm('¿Seguro de eliminar el grupo?')) return;

    setImportData((importData) => {
      let newImportData = [...importData];
      newImportData = newImportData.concat(group.items);
      newImportData.sort((a, b) => a.id - b.id);
      return newImportData;
    });

    setGroups((groups) => {
      let newGroups = [...groups];
      let index = newGroups.findIndex((item) => item.id === group.id);
      newGroups.splice(index, 1);
      return newGroups;
    });
  }

  function deleteItemFromGroup(group, item) {
    setImportData((importData) => {
      let newImportData = [...importData];
      newImportData.push(item);
      newImportData.sort((a, b) => a.id - b.id);
      return newImportData;
    });

    setGroups((groups) => {
      let newGroups = [...groups];
      let index = newGroups.findIndex((g) => g.id === group.id);
      let itemIndex = newGroups[index].items.findIndex((i) => i.id === item.id);
      newGroups[index].items.splice(itemIndex, 1);
      return newGroups;
    });
  }

  const gridColumns = useMemo(() => {
    const cols = [...columns];

    cols.push({
      field: 'Acciones',
      headerName: 'Acciones',
      width: 75,
      renderCell: (params) => {
        return (
          <RegularButton
            justIcon
            round
            color="danger"
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              deleteDeposit(params.row);
            }}
          >
            <Delete />
          </RegularButton>
        );
      },
    });

    cols.push({
      field: 'Motivo',
      headerName: 'Motivo',
      width: 120,
      sortable: false,
      renderCell: (params) => {
        const reason = params.row.mismatchReason;
        return reason ? (
          <InputAdornment style={{ cursor: 'pointer', color: '#00a1ff' }} position="start" >
              <IconButton onClick={() => alert(reason)} style={{
                color: '#00a1ff',
              }}>
                <Icon>{icon}</Icon>
              </IconButton>
          </InputAdornment>
        ) : null;
      },
    });

    return cols;
  }, [columns]);

  async function save() {
    setProcessing(true);
    let res = await wsPost('pymt/deposit/massive-store', {
      groups,
    });

    if (res.success) {
      alert(res.message);
      window.location.href = '/admin/bancos/operaciones/depositos/';
    } else {
      setProcessing(false);
      alert(res.message);
    }
  }

  return (
    <>
      <Collapse in={!(importData.length === 0)}>
        <CardContainer icon={null}>
          <GridItem xs={12} style={{ height: '500px' }}>
            <DataGrid
              selectionModel={selectionModel}
              onSelectionModelChange={setSelectionModel}
              localeText={esES.props.MuiDataGrid.localeText}
              columns={gridColumns}
              rows={importData}
              checkboxSelection
              // disableColumnFilter
              // disableColumnMenu
              disableColumnReorder
              getRowClassName={(params) => {
                if (!mismatchIds.has(params.id)) return '';
                const type = params.row.mismatchType;
                if (type === 'ref2') return classes.rowRefUsed;
                return classes.rowMismatch;
              }}
              onCellEditCommit={(params) => {
                setValidateExtracto(false);
                const { id, field, value } = params;
                let isValid = true;
                if (field === 'TaxDate') {
                  const dateRegex = /^\d{4}-\d{2}-\d{2}$/;
                  if (!dateRegex.test(value) || isNaN(new Date(value).getTime())) {
                    alert('La fecha debe tener formato válido YYYY-MM-DD');
                    isValid = false;
                  }
                }
                if (field === 'Ref2') {
                  if (!/^\d+$/.test(value)) {
                    alert('La referencia debe contener solo números');
                    isValid = false;
                  }
                }
                if (field === 'LocTotal') {
                  if (!/^-?\d+(\.\d{1,2})?$/.test(value)) {
                    alert('El monto debe ser un número válido con máximo 2 decimales');
                    isValid = false;
                  }
                }
                if (field === 'U_SYP_MPPG') {
                  const allowed = ['001', '002', '003'];
                  if (!allowed.includes(value)) {
                    alert('El método de pago debe ser "001", "002" o "003"');
                    isValid = false;
                  }
                }
                if (!isValid) return;
                setImportData(prev =>
                  prev.map(row =>
                    row.id === id ? { ...row, [field]: value } : row
                  )
                );
              }}

            />
          </GridItem>
        </CardContainer>
      </Collapse>

      {groups.length > 0 && (
        <>
          <GridContainer>
            {groups.map((group, index) => {
              return (
                <DepositGroup
                  group={group}
                  setGroups={setGroups}
                  index={index}
                  deleteGroup={deleteGroup}
                  deleteItemFromGroup={deleteItemFromGroup}
                />
              );
            })}
          </GridContainer>
          <GridContainer>
            <GridItem xs={12} xl={2}>
              <RegularButton
                color="success"
                disabled={procesing || importData.length > 0}
                onClick={save}
              >
                Procesar
              </RegularButton>
            </GridItem>
          </GridContainer>
        </>
      )}
    </>
  );
}

export default ImportDeposits;
